import SmallCheck from '@assets/small_check';
import { Body1, Heading2, Subtitle1, Subtitle2 } from '@components/Texts/Texts';
import tw, { css, styled, theme } from 'twin.macro';

export const ProfileFormContainer = styled.div`
  ${tw`flex flex-col text-light-high`};
`;

export const ProfileFormName = styled(Heading2)``;

export const ProfileFormDivider = styled.div<{ margin: boolean }>`
  ${tw`w-full`};
  ${props => (props.margin ? tw`my-3` : undefined)};
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ProfileFormMessage = styled(Subtitle1)`
  ${tw`mb-2 text-light-medium`}
`;

export const ProfileFormTabContainer = styled.div`
  ${tw`flex flex-row items-center space-s-2`};
`;

export const ProfileFormInfoContainer = styled.div`
  background-color: rgba(255, 255, 255, 0.1);
  border: 1.5px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  ${tw`relative w-full mt-4 flex flex-col`}

  ${css`
    @media (min-width: ${theme`screens.lg.min`}) {
      background-color: rgba(24, 24, 27, 0.1);
      backdrop-filter: blur(8px);
    }
  `}
`;

export const ProfileFormInfoTopContainer = styled.div`
  display: flex;
  ${tw`p-2`};
`;

export const ProfileFormFooterContainer = styled.div`
  ${tw`flex py-1 px-3 space-s-2`}
`;

export const ProfileFormFooterText = styled(Subtitle2)`
  ${tw`flex flex-1 text-light-medium`}
`;

export const ProfileFormFooterTextIcon = styled(SmallCheck)`
  ${tw`me-1`}
`;
